import { render } from "./PostCategories.vue?vue&type=template&id=3d292da9"
import script from "./PostCategories.vue?vue&type=script&lang=js"
export * from "./PostCategories.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/khatoncollection-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__